import { render } from "./AdminRoles.vue?vue&type=template&id=59ee8284&scoped=true&ts=true"
import script from "./AdminRoles.vue?vue&type=script&lang=ts"
export * from "./AdminRoles.vue?vue&type=script&lang=ts"

import "./AdminRoles.vue?vue&type=style&index=0&id=59ee8284&scoped=true&lang=css"
import "./AdminRoles.vue?vue&type=style&index=1&id=59ee8284&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59ee8284"]])

export default __exports__